export interface LastGeneratedReport {
  date: string;
  url: string;
}

export interface ReportHistoryItem {
  id: string;
  date: string;
  url: string;
  generatedBy: {
    id: number;
    name: string;
    email: string;
  } | null;
  periodOrBreakDate: string | null;
  payload: Record<string, any>;
}

export interface ReportAsyncTypeRow {
  id: string;
  name: string;
  description: string;
  instructions: string;
  dynamicFormId: number | null;
  generating: boolean;
  lastGenerated: LastGeneratedReport | null;
  history: ReportHistoryItem[];
}

export interface ReportAsyncForm {
  structure: any[];
  options?: Record<string, any>;
}

export enum ReportAsyncGroup {
  Default = 'default',
  Coursables = 'coursables',
  SIES = 'sies',
  SNIES = 'snies',
}
